/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandGrammarly = createReactComponent("outline", "brand-grammarly", "IconBrandGrammarly", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15.697 9.434a4.5 4.5 0 1 0 .217 4.788", "key": "svg-1" }], ["path", { "d": "M13.5 14h2.5v2.5", "key": "svg-2" }]]);

export { IconBrandGrammarly as default };
//# sourceMappingURL=IconBrandGrammarly.mjs.map
